<div class="dialog-container state-dialog">
  <div class="dialog-body">
    <div class="title">{{'OUTOF.OH' | translate}}</div>
    <div class="text">{{'OUTOF.TEXT' | translate}}</div>
  </div>
  <div class="confirm-btn">
    <button class="w-btn orange-btn" mat-dialog-close>{{'CLOSE' | translate}}</button>
  </div>
</div>
